/**
 * SacFilterType
 * @author Thacryba
 */

export enum SacBostonFilterType {
  NF = 1,
}
